import { breakpoints, css, fluidRange, respondTo, styled } from '~/styles';
import Wrapper from '~/components/layout/Wrapper';

export const ResourcesContainerOuter = styled(Wrapper)`
  ${respondTo(breakpoints.md, css`
    padding-left: 0;
    padding-right: 0;
  `)};
`

export const ResourcesContainer = styled.div`
  /* background: rgba(0, 0, 0, 0.7); */
  width: 100%;
  max-width: 1500px;
  min-height: 60vh;
  margin: 0 auto;
  ${fluidRange('marginTop', '5px', '10px')}
  ${fluidRange('marginBottom', '20px', '40px')}

  ${respondTo(breakpoints.md, css`
    margin-bottom: 0;
  `)};
`



// WEBPACK FOOTER //
// ./src/components/layout/resources/ResourcesContainer.tsx